import { FORGE_MODULE_PAGE_BANNER, FORGE_MODULE_XEN_MACRO } from './ForgeModuleType.ts';
import type { preloadUseExtensionList } from './hooks/preloadUseExtensionList.ts';

/**
 * Keep banner discovery consistent across page routes without changing their existing macro policy.
 * The banner snapshot belongs to the initial server-rendered route; client navigation must discover
 * apps for its new context. Callers must await this preload before rendering the main layout, even
 * when content is deferred behind a streaming boundary.
 */
export const getPageExtensionListPreloadOptions = ({
	contentId,
	spaceKey,
	preloadMacros,
	isTransition = false,
	includePageBanner = true,
}: {
	contentId: string;
	spaceKey: string;
	preloadMacros: boolean;
	isTransition?: boolean;
	includePageBanner?: boolean;
}): Parameters<typeof preloadUseExtensionList>[0] | undefined => {
	const preloadBanner =
		// This only schedules server work; the snapshot is also consumed during hydration.
		// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
		Boolean(process.env.REACT_SSR) &&
		!isTransition &&
		includePageBanner &&
		Boolean(contentId && spaceKey);

	if (preloadMacros) {
		return {
			contentId,
			spaceKey,
			moduleType: FORGE_MODULE_XEN_MACRO,
			...(preloadBanner ? { additionalModuleTypes: [FORGE_MODULE_PAGE_BANNER] } : {}),
		};
	}

	return preloadBanner ? { contentId, spaceKey, moduleType: FORGE_MODULE_PAGE_BANNER } : undefined;
};
